import SFStepper from '@/component/common/sf-stepper';
import TopBackButton from '@/component/common/top-back-button';
import SignUpForm from '@/component/auth/sign-up-form';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

export default function SignUp() {
  return (
    <Container maxWidth="sm">
      <Box position="sticky" top={0} bgcolor="white" zIndex={100}>
        <TopBackButton
          title="회원가입"
          boxProps={{
            mb: 2,
          }}
        />
        <SFStepper
          steps={['1', '2', '3', '4']}
          activeStep={1}
          stepperProps={{
            sx: {
              width: 200,
              ml: '-10px',
              pb: 2,
            },
          }}
        />
      </Box>
      <Box pt={4}>
        <Typography variant="h4" mb={3.5}>
          {'반갑습니다 :)'}
          <br />
          <b>가입약관을 확인해 주세요!</b>
        </Typography>
        <SignUpForm />
      </Box>
    </Container>
  );
}
